'use strict';

var styled = require('styled-components');
require('../../Dropdown/component.js');
var Item = require('../../Dropdown/Item.js');
require('../../Dropdown/ItemGroup.js');
var styles = require('../../Text/styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const placeholderStyles = styled.css `
  ${styles.Styled} {
    color: ${({ theme }) => theme.designTokens.controlPlaceholderTextColor};
  }
`;
const DropdownOption = styled__default.default(Item.DropdownItem) `
  ${({ isPlaceholder }) => isPlaceholder && placeholderStyles};
  ${({ isPlaceholder }) => isPlaceholder &&
    `
    :hover,
    &.hover {
      cursor: default;
    }
    :focus,
    &.focus {
      background: none;
    }
  `};
`;
const Placeholder = styled__default.default.div `
  color: ${({ theme }) => theme.designTokens.controlPlaceholderTextColor};
`;
const RadioContainer = styled__default.default.div `
  display: flex;
  align-items: center;
  padding: 0 ${({ theme }) => theme.designTokens.selectSimpleRadioPaddingX};
`;
const Styled = {
    DropdownOption,
    RadioContainer,
    Placeholder,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
